import axios from 'axios';
import { PatchWithComment } from 'launchdarkly-api-typescript';

export const updateFlag = async (
    featureFlagKey: string,
    patchComment: PatchWithComment,
    toastText?: {
        onSuccessText?: string;
        onPendingText?: string;
    }
) =>
    axios
        .patch(`/featureflag/features/${featureFlagKey}`, patchComment, {
            headers: {
                'Toast-Pending-Text': toastText?.onPendingText,
                'Toast-Success-Text': toastText?.onSuccessText,
            },
        })
        .then((res) => res.data)
        .catch((error) => {
            throw error;
        });
